import { AfterViewInit, Component, ElementRef, Renderer2, ViewChild, ViewEncapsulation } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { LoginService } from '../../core/login/login.service';
import { DomainService } from '../../services/domain.service';
import { Domain } from '../../models/domain';
import { Subscription } from 'rxjs';
import { finalize } from 'rxjs/operators';
import { ToastContainerDirective } from 'ngx-toastr';
import { AtlasToastService } from '../../services/atlas-toast.service';
import { NgbModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { UserService } from '../../services/user.service';
import { ProfileService } from '../../services/profile.service';
import { SessionStorageService } from 'ngx-webstorage';
import { faEye, faEyeSlash } from '@fortawesome/free-solid-svg-icons';
import { environment } from '../../../environments/environment';
import { User } from '@models/user';

@Component({
  selector: 'wsb-login-component',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss'],
  encapsulation: ViewEncapsulation.None,
  standalone: false
})
export class LoginComponent implements AfterViewInit {
  @ViewChild('username') username?: ElementRef;
  @ViewChild('modalReset') modalReset;
  @ViewChild('modalExpirePWD') modalExpirePWD;
  modalResetModal: NgbModalRef;
  modalExpirePWDRef: NgbModalRef;
  @ViewChild(ToastContainerDirective) toastContainer: ToastContainerDirective;
  @ViewChild(ToastContainerDirective) toastContainerFastSmsMigrated: ToastContainerDirective;
  @ViewChild(ToastContainerDirective) toastContainerAuth0Disclaimer: ToastContainerDirective;
  resetForm: UntypedFormGroup = this.fb.group({
    username: ['', [Validators.required]]
  });
  accoutExpiredPwd;
  accoutExpiredPwdMail;
  isExpiredPwd = false;

  loginForm = this.fb.group({
    username: [''],
    password: [''],
    rememberMe: [false]
  });
  domain: Domain;
  loading = false;
  faPasswordIconShow = faEye;
  showPassword = false;
  displayfastSmsMigrated = false;
  daysAuth0Limit;
  constructor(
    private loginService: LoginService,
    private renderer: Renderer2,
    private router: Router,
    private fb: UntypedFormBuilder,
    private domainService: DomainService,
    private userService: UserService,
    private profileService: ProfileService,
    private atlasToastService: AtlasToastService,
    private sessionStorage: SessionStorageService,
    private modalService: NgbModal
  ) {}

  ngOnInit(): void {
    this.domainService.getDomainState().subscribe(x => {
      this.domain = x;
      // switch (this.domain.brand.systemId.toLowerCase()) {
      //   case 'esendexau':
      //   case 'mediaburst':
      //     this.daysAuth0Limit = 4;
      //     break;
      //   case 'mobyt':
      //   case 'mobytfr':
      //   case 'smsenvoi':
      //   case 'trend':
      //     this.daysAuth0Limit = 11;
      //     break;
      //   case 'aruba':
      //   case 'skebby':
      //   case 'farm':
      //   case 'library':
      //   case 'lowcost':
      //   case 'comunitrentini':
      //     this.daysAuth0Limit = 18;
      //     break;
      // }
      // if (this.daysAuth0Limit) {
      //   this.atlasToastService.info('login_disclaimer_auth0', null, -1, this.toastContainerAuth0Disclaimer, { day: this.daysAuth0Limit });
      // }
    });
  }

  ngAfterViewInit(): void {
    if (this.username) {
      this.renderer.selectRootElement(this.username.nativeElement).focus();
    }
    if (this.sessionStorage.retrieve('login-message')) {
      this.atlasToastService.info(this.sessionStorage.retrieve('login-message'), null, 6000000, this.toastContainer);
      this.sessionStorage.clear('login-message');
    }

    if (this.router.url === '/loginfastsms') {
      this.displayfastSmsMigrated = true;
      this.atlasToastService.info('login_fs_disclaimer', null, 6000000, this.toastContainerFastSmsMigrated);
    }
  }

  getLabelUsername(): string {
    const today = new Date();
    const dateLimiteAuth0 = new Date(2023, 3, this.daysAuth0Limit);
    if (today < dateLimiteAuth0) {
      return 'login_username';
    } else {
      return 'login_username_v2';
    }
  }

  openModalReset(e?: any): void {
    this.modalResetModal = this.modalService.open(this.modalReset);
    // this.modalResetModal.result.then(
    //   result => {},
    //   reason => {}
    // );
  }

  modalResetForm(): void {
    if (!this.resetForm.valid) {
      return;
    }
    this.resetForm.disable();
    const raw = this.resetForm.getRawValue();
    this.profileService.resetSend(raw.username).subscribe(
      () => {
        this.resetForm.reset();
        this.atlasToastService.success('login_passreset_success_title', 'login_passreset_success_text', 600000, this.toastContainer);
        this.resetForm.enable();
      },
      () => {
        this.atlasToastService.error('common_error', null);
        this.resetForm.enable();
      },
      () => {}
    );
    this.modalResetModal.close();
  }

  cancel(): void {
    this.loginForm.patchValue({
      username: '',
      password: ''
    });
  }

  login(): Subscription {
    this.loading = true;
    return this.loginService
      .login({
        username: this.loginForm.controls.username.value,
        password: this.loginForm.controls.password.value
      })
      .pipe(finalize(() => (this.loading = false)))
      .subscribe(
        data => {
          const user = User.deserialize(data);
          // Redirect to studio or other services if logged
          this.loginService.getTokenExchange().subscribe(
            tokenExchange => {
              if (!this.userService.checkRedirectToReturnUrl(tokenExchange)) {
                if (
                  this.router.url === '/account/register' ||
                  this.router.url.startsWith('/account/activate') ||
                  this.router.url.startsWith('/account/reset/') ||
                  this.router.url.startsWith('/login')
                ) {
                  // if password is expired then show reset password pop up
                  if (user.profile?.resetPassword) {
                    this.accoutExpiredPwd = user.profile.userName;
                    // to modify with the mail field after fix BE for get-user issue
                    this.accoutExpiredPwdMail = user.profile.email;
                    this.openModalExpirePWD();
                  } else {
                    this.sessionStorage.store('wsb-popup-registrationMail', true);
                    this.router.navigate(['dashboard']);
                  }
                }
              }
            },
            error => {
              console.error('Error during token exchange', error);
            }
          );
        },
        () => {
          this.atlasToastService.error('login_login_error', null, 600000, this.toastContainer);
        }
      );
  }

  register(): void {
    this.router.navigate(['/account/register']);
  }

  requestResetPassword(): void {
    this.router.navigate(['/account/reset', 'request']);
  }

  showHidePassWord() {
    this.showPassword = !this.showPassword;
    if (this.showPassword) {
      this.faPasswordIconShow = faEyeSlash;
    } else {
      this.faPasswordIconShow = faEye;
    }
  }

  displayDisclaimer() {
    return environment.brandName === 'aruba';
  }

  private openModalExpirePWD() {
    this.logoutByExpiredPWD();
    this.modalExpirePWDRef = this.modalService.open(this.modalExpirePWD);
    this.modalExpirePWDRef.result.then(
      result => {},
      reason => {
        this.closeModalExpirePWD();
      }
    );
  }

  btnModalExpirePWD() {
    if (!this.accoutExpiredPwd) {
      return;
    }
    this.profileService.resetSend(this.accoutExpiredPwd).subscribe(
      () => {
        this.isExpiredPwd = true;
        this.atlasToastService.successResetPwdExpired(
          'login_passreset_success_title',
          'login_passreset_expired_success_text',
          this.accoutExpiredPwdMail,
          -1,
          this.toastContainer
        );
      },
      () => {
        this.atlasToastService.error('common_error', null);
        this.resetForm.enable();
      },
      () => {}
    );
    this.closeModalExpirePWD();
  }

  private closeModalExpirePWD() {
    this.modalExpirePWDRef.close();
  }

  private logoutByExpiredPWD(): void {
    this.loginService.destroySession();
    this.loginService.logout(false);
    this.loginService.clearAllCookies();
  }
}
